export function runIfFunction(value, ...args) {
  return typeof value === "function" ? value(...args) : value;
}

/**
 * A function that merges React refs into one
 */
export function mergeRefs(refs) {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref !== null) {
        // eslint-disable-next-line
        ref.current = value;
      }
    });
  };
}
